import { ProjectDescriptionFormOutput } from "../../pages/Profile/EditProject/Tabs/ZodValidationSchema/DescriptionSchema"
import { parseTagsInput } from "../../pages/Profile/EditProject/Tabs/EditDescriptionForm/helpers/tags"
import { parseExternalLinksInput } from "../../pages/Profile/EditProject/Tabs/EditDescriptionForm/helpers/externalLinks"

const trimStr = (s: string) => s.trim()
const strEq = (a: string, b: string) => trimStr(a) === trimStr(b)
const tagsEq = (a: string | null | undefined, b: string | null | undefined) => {
    const aa = parseTagsInput((a ?? "").trim())
    const bb = parseTagsInput((b ?? "").trim())
    if (aa.length !== bb.length) return false
    for (let i = 0; i < aa.length; i++) {
        if (aa[i] !== bb[i]) return false
    }
    return true
}
const externalLinksEq = (a: string | null | undefined, b: string | null | undefined) => {
    const aa = parseExternalLinksInput(a ?? "")
    const bb = parseExternalLinksInput(b ?? "")
    if (aa.length !== bb.length) return false
    for (let i = 0; i < aa.length; i++) {
        if (aa[i] !== bb[i]) return false
    }
    return true
}

export function areProjectDescriptionFormOutputsEqual(
    a: ProjectDescriptionFormOutput,
    b: ProjectDescriptionFormOutput,
): boolean {
    if (!strEq(a.name, b.name)) return false
    if (!strEq(a.type, b.type)) return false
    if (!strEq(String(a.stage), String(b.stage))) return false
    if (!strEq(a.region, b.region)) return false
    if (!strEq(a.description, b.description)) return false
    if (!strEq(a.full_description ?? '', b.full_description ?? '')) return false
    if (!strEq(a.env_factor, b.env_factor)) return false
    if (!strEq(a.expected_result, b.expected_result)) return false
    if (!strEq(a.initial_state, b.initial_state)) return false
    if (!strEq(a.necessary_actions, b.necessary_actions)) return false
    if (!strEq(a.implementation, b.implementation)) return false
    if (!tagsEq(a.tags, b.tags)) return false
    if (!strEq(a.city, b.city)) return false
    if (!strEq(a.address, b.address)) return false
    if (!strEq(a.website, b.website)) return false
    if (!externalLinksEq(a.external_links, b.external_links)) return false
    if (!strEq(a.status, b.status)) return false
    return true
}